import { useEffect } from 'react';
import QRCode from '../../components/QRCode';

export default function QRPrintPage() {
  useEffect(() => {
    // Add print-specific styles
    document.body.style.margin = '0';
    document.body.style.padding = '0';
    
    return () => {
      document.body.style.margin = '';
      document.body.style.padding = '';
    };
  }, []);

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Screen View - Print Button */}
      <div className="print:hidden fixed top-6 right-6 z-50">
        <button
          onClick={handlePrint}
          className="bg-gradient-to-r from-purple-500 to-pink-500 text-white px-8 py-4 rounded-xl font-bold shadow-lg hover:shadow-2xl transition-all hover:scale-105 flex items-center gap-3 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-printer-line text-xl"></i>
          Print QR Code
        </button>
      </div>

      {/* Print Layout */}
      <div className="flex items-center justify-center min-h-screen p-8">
        <div className="text-center max-w-2xl">
          {/* Logo */}
          <div className="mb-8 flex justify-center">
            <img 
              src="https://static.readdy.ai/image/8ba2fb49baf129fe47398873ffc1b622/ae217e5ef1f4a035b7b045b6b3280b3a.jpeg" 
              alt="Fluffy Pets Logo" 
              className="w-64 h-auto object-contain"
            />
          </div>

          {/* Title */}
          <h1 className="text-5xl font-black mb-4 bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent print:text-purple-600">
            Fluffy Pets
          </h1>
          <p className="text-2xl text-gray-700 mb-8 font-semibold">
            Premium Pet Care Services
          </p>

          {/* QR Code */}
          <div className="flex justify-center mb-8">
            <div className="bg-white p-8 rounded-3xl shadow-2xl print:shadow-none">
              <QRCode 
                url={`${window.location.origin}/qr`}
                size={300}
                showDownload={false}
              />
            </div>
          </div>

          {/* Instructions */}
          <div className="space-y-4 text-gray-700">
            <p className="text-xl font-semibold">
              Scan to visit our website
            </p>
            <p className="text-lg">
              {window.location.origin}
            </p>
          </div>

          {/* Contact Info */}
          <div className="mt-12 pt-8 border-t-2 border-gray-200 space-y-3">
            <div className="flex items-center justify-center gap-3 text-lg">
              <i className="ri-phone-line text-purple-600"></i>
              <span className="font-semibold">+1 (555) 123-4567</span>
            </div>
            <div className="flex items-center justify-center gap-3 text-lg">
              <i className="ri-mail-line text-purple-600"></i>
              <span className="font-semibold">hello@fluffypets.com</span>
            </div>
            <div className="flex items-center justify-center gap-3 text-lg">
              <i className="ri-map-pin-line text-purple-600"></i>
              <span className="font-semibold">123 Pet Care Lane, San Francisco, CA 94102</span>
            </div>
          </div>

          {/* Services List */}
          <div className="mt-12 grid grid-cols-2 gap-4 text-left">
            <div className="space-y-2">
              <h3 className="font-bold text-lg text-purple-600 mb-3">Our Services:</h3>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-center gap-2">
                  <i className="ri-check-line text-pink-500"></i>
                  Pet Grooming
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-check-line text-pink-500"></i>
                  Pet Boarding
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-check-line text-pink-500"></i>
                  Veterinary Care
                </li>
              </ul>
            </div>
            <div className="space-y-2">
              <h3 className="font-bold text-lg text-purple-600 mb-3">Business Hours:</h3>
              <ul className="space-y-2 text-gray-700">
                <li>Mon-Fri: 8:00 AM - 7:00 PM</li>
                <li>Saturday: 9:00 AM - 6:00 PM</li>
                <li>Sunday: 10:00 AM - 5:00 PM</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Print Styles */}
      <style>{`
        @media print {
          @page {
            size: A4;
            margin: 1cm;
          }
          
          body {
            print-color-adjust: exact;
            -webkit-print-color-adjust: exact;
          }
          
          .print\\:hidden {
            display: none !important;
          }
          
          .print\\:shadow-none {
            box-shadow: none !important;
          }
          
          .print\\:text-purple-600 {
            color: #9333ea !important;
            background: none !important;
            -webkit-background-clip: unset !important;
            -webkit-text-fill-color: unset !important;
          }
        }
      `}</style>
    </div>
  );
}
